import { Editor } from 'grapesjs';
import { upgradeStandardButtons } from '../pages/Editor/utils/standardTemplateButtons';

export enum ProjectFileCommands {
    EXPORT_PROJECT = 'export-project',
    IMPORT_PROJECT = 'import-project'
}

export default function(editor: Editor){
    
    editor.Commands.add(ProjectFileCommands.EXPORT_PROJECT, {
        run(editor) {
            const projectData = editor.getProjectData();
            
            const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(projectData));
            const downloadAnchor = document.createElement("a");
            downloadAnchor.setAttribute("href", dataStr);
            downloadAnchor.setAttribute("download", "grapesjs-project.json");
            document.body.appendChild(downloadAnchor);
            downloadAnchor.click();
            document.body.removeChild(downloadAnchor);
        }
    });

    editor.Commands.add(ProjectFileCommands.IMPORT_PROJECT, {
        run(editor) {
            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = 'application/json';
            
            fileInput.addEventListener('change', (event) => {
                const file = (event.target as HTMLInputElement).files?.[0];
                if (!file) return;
                
                const reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        const projectData = JSON.parse(e.target?.result as string);
                        editor.loadProjectData(upgradeStandardButtons(projectData));
                    } catch (error) {
                        console.error('Invalid project file:', error);
                    }
                };
                reader.readAsText(file);
            });
            
            fileInput.click();
        }
    });
}